import { objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { LayoutType } from '../types/layouts.esm.js';
import { sameArray } from './same-array.esm.js';

var initialDiffedSavedLayouts = function initialDiffedSavedLayouts(addedLayouts) {
  return {
    changedLayouts: [],
    deletedLayouts: [],
    addedLayouts: addedLayouts
  };
};
var diffSavedLayouts = function diffSavedLayouts(liveLayouts, newLayouts) {
  var liveSavedLayouts = liveLayouts.filter(function (l) {
    return l.type === LayoutType.Saved;
  });
  var newSavedLayouts = newLayouts.filter(function (l) {
    return l.type === LayoutType.Saved;
  });
  var addedLayouts = newSavedLayouts.reduce(function (acc, current) {
    var exists = liveSavedLayouts.some(function (l) {
      return l.id === current.id;
    });
    if (!exists) {
      return [].concat(_toConsumableArray(acc), [current]);
    }
    return acc;
  }, []);
  return liveSavedLayouts.reduce(function (acc, current) {
    var newVersion = newSavedLayouts.find(function (l) {
      return l.id === current.id;
    });
    if (newVersion) {
      var hasDifferences = !sameArray(newVersion.fields, current.fields);
      if (hasDifferences) {
        var details = {
          newVersion: newVersion,
          oldVersion: current
        };
        return _objectSpread2(_objectSpread2({}, acc), {}, {
          changedLayouts: [].concat(_toConsumableArray(acc.changedLayouts), [details])
        });
      }
    } else {
      return _objectSpread2(_objectSpread2({}, acc), {}, {
        deletedLayouts: [].concat(_toConsumableArray(acc.deletedLayouts), [current])
      });
    }
    return acc;
  }, initialDiffedSavedLayouts(addedLayouts));
};

export { diffSavedLayouts };
//# sourceMappingURL=diff-saved-layouts.esm.js.map
